import { useState } from "react"
import { GGNLocations } from '../../interfaces/intakes.reports';
import { IoPartlySunnyOutline } from "react-icons/io5";
import { ModalGGNLocations } from "./ModalGGNLocations";

interface Props {
    reportId: string
    weather: GGNLocations[]
    mainData_loading_date: Date
}

export const GGNComponent = ({reportId, weather, mainData_loading_date}:Props) => {

    const [openGGN, setOpenGGN] = useState(false)

    return (
        <>
            {
                openGGN &&
                <ModalGGNLocations
                    closeModal={() => setOpenGGN(false)}
                    reportId={reportId}
                    weather={weather}
                    mainData_loading_date={mainData_loading_date}
                />
            }

            <button
                className='btn-copy mb-1 ml-05'
                onClick={() => setOpenGGN(true)}
            >
                <IoPartlySunnyOutline size={16} color="#1A73E8"/>
            </button>

        </>
    )
}